export default __webpack_public_path__ + "static/media/labra-white.6d4109e1.svg";